import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";

export const LockedFeature = ({ description }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-2xl border border-stone-border shadow-sm p-10 text-center" data-testid="locked-feature">
      <div className="w-14 h-14 rounded-2xl bg-brand-soft flex items-center justify-center mx-auto mb-4">
        <Lock className="w-7 h-7 text-brand" />
      </div>
      <h3 className="font-heading text-xl font-bold text-stone-text mb-2">{t("employer.locked.title")}</h3>
      <p className="text-stone-sub max-w-md mx-auto mb-5">{description}</p>
      <button data-testid="locked-upgrade-btn" onClick={() => navigate("/employer/plans")} className="px-6 py-3 rounded-xl bg-brand text-white font-semibold hover:bg-brand-hover transition-colors">
        {t("employer.locked.cta")}
      </button>
    </div>
  );
};
